import { useEffect } from 'react';
import { useDebounce } from 'usehooks-ts';

import PlaygroundEditor from '../../components/common/PlaygroundEditor/PlaygroundEditor';
import {
  useEditorStore,
  useTemporalEditorStore,
} from '../../services/store/playground-editor.store';
import { AI_WRITER_EDITOR_LAST_TEXT } from '../../configs';
import { useEditorRecentStore } from '../../services/store/playground-editor-recents';
import { ResultType } from '../../utils/common/types';
import { KEYWORD_GENERATOR_CATEGORY } from '../../constants';

export default function PersistentEditor() {
  const { undo, redo, futureStates, pastStates } = useTemporalEditorStore((state) => state);

  const { addOrEdit: addOrEditRecent, remove: removeRecentById } = useEditorRecentStore(
    (state) => state,
  );

  const {
    id: currentEditorId,
    text,
    error,
    isOpen,
    writeText,
    toggleOpen,
    setError: clearError,
  } = useEditorStore((state) => state);

  const debouncedText = useDebounce(text, 600);

  useEffect(() => {
    sessionStorage.setItem(AI_WRITER_EDITOR_LAST_TEXT, debouncedText);

    if (debouncedText === '') {
      removeRecentById(currentEditorId);
    } else {
      addOrEditRecent({
        isSensitive: false,
        id: currentEditorId,
        rephrasedResults: [],
        result: debouncedText,
        type: ResultType.Recent,
        category: KEYWORD_GENERATOR_CATEGORY,
      });
    }
  }, [debouncedText]);

  return (
    <PlaygroundEditor
      undo={undo}
      redo={redo}
      value={text}
      error={error}
      isOpen={isOpen}
      setValue={writeText}
      onToggle={toggleOpen}
      canDo={pastStates.length > 0}
      canRedo={futureStates.length > 0}
      closeError={() => clearError(null)}
    />
  );
}
